/**
 * This middleware redirects logged-in users away from pages like login, register etc
 */

export default defineNuxtRouteMiddleware(async () => {
  const auth = useAuth()

  if (!auth.isLoggedIn) {
    return
  }

  await auth.navigateToHome({ from: 'guest middleware' })
})
